module.exports = __webpack_public_path__ + "static/img/two-piece-1.e45f990.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/two-piece-1.jpg
// module id = SEW4
// module chunks = 1